import { useCallback, useRef } from 'react';

export const useScrollToBottom = () => {
    const isScrolling = useRef(false);

    const scrollToBottom = useCallback((delay: number = 0) => {
        if (isScrolling.current) return;

        isScrolling.current = true;
        setTimeout(() => {
            const chatWindow = document.getElementById('chat-window-container');
            if (chatWindow) {
                chatWindow.scrollTo({
                    top: chatWindow.scrollHeight,
                    behavior: 'smooth'
                });
            }
            setTimeout(() => {
                isScrolling.current = false;
            }, 300); // 防抖
        }, delay);
    }, []);

    return { scrollToBottom };
}; 